import { AgTechButtonProps } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechSelectionButton from "@agtech/web/components/Buttons/AgTechSelectionButton";
import AgTechHeaderDetail from "@agtech/web/components/Headers/AgTechHeaderDetail";
import AgTechSearchControl from "@agtech/web/components/Widgets/AgTechSearchControl";
import { AgTechGridSearchState } from "@agtech/web/components/Grids/Features/AgTechGridSearching";
import ContactDialog from "../../dialogs/ContactDialog";
import { useContactSelectionProps } from '../selections/ContactSelectionControl';
import { AgTechContact } from '@agtech/data/contacts/ContactData';

export type ContactSelectionProps = {
    contacts?: AgTechContact[],
    filter?: (contact: AgTechContact) => boolean,
    selectedContactId?: number,
    onContactSelected: (contact: AgTechContact) => Promise<void>
}

export const ContactSelectionButton = (props: ContactSelectionProps & AgTechButtonProps) => {
    const contactSelectionProps = useContactSelectionProps({
        onContactSelected: props.onContactSelected,
        selectedContactId: props.selectedContactId,
        filterContacts: props.filter
    });
    
    return (
        <AgTechSelectionButton
            text='Split lot'
            icon='fas fa-clone'
            {...props}
            selectionProps={{
                items: {
                    ...contactSelectionProps.items
                },
                content: {
                    ...contactSelectionProps.content,
                    header: headerProps => (
                        <div className='row-based stretched py-2 container'>
                            <AgTechHeaderDetail
                                header="Contacts"
                                settings={{
                                    header: {
                                        classes: 'text-md'
                                    },
                                    content: {
                                        classes: 'ml-auto',
                                        body: () => (
                                            <AgTechSearchControl
                                                placeholder='Search contacts...'
                                                options={[
                                                    { field: 'Name', value: cnt => cnt.firstName + ' ' + cnt.lastName}
                                                ]}
                                                onUpdateSearchState={(searchState: AgTechGridSearchState<AgTechContact>) => {
                                                    const visibleItems = headerProps.state.allItems.filter(item => 
                                                        searchState.selectedField.value(item).toLowerCase().includes(searchState.filter.toLowerCase()));
                                                        
                                                    headerProps.handlers.onItemsUpdated(visibleItems);
                                                }}
                                                width={180}
                                                styles={{ height: 32 }}
                                            />
                                        )
                                    }
                                }}
                            />
                        </div>
                    ),
                    footer: footerProps => (
                        <div className='wide column-based-vertically-centered container'>
                            <ContactDialog.Button
                                classes='link ml-auto'
                                onContactSubmitted={footerProps.handlers.onItemSelected}
                            />
                        </div>
                    ),
                    styles: { height: 320, width: 420 }
                }
            }}
        />
    )
}